import { Col, Row } from "antd";
import React, { useContext, useMemo } from "react";

import { t } from "i18next";
import { MandatoryField } from "../../../../../components/MandatoryField/MandatoryField";
import { MinistryContext } from "../../../../../modules/ministry/ministry.context";
import { ExciseStampsContext } from "../../../../../modules/obligee/exciseStamps/exciseStamps.context";
import { mapPodaciOTrazenimMarkicamaPrint } from "../../../../../modules/obligee/exciseStamps/exciseStamps.functions";
import {
  AkciznaMarkicaKategorijaProzivoda,
  IPodaciOTrazenimMarkicamaPrint,
  RequestedStampsInfoTableColumnName,
} from "../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import { RequestedStampsInfoTable } from "../../../../components/StampDetails/components/RequestedStampsInfoTable/RequestedStampsInfoTable";
import { ChooseRequestedStampsRow } from "./components/ChooseRequestedStampsRow/ChooseRequestedStampsRow";
import style from "./RequestedStampsInfo.module.scss";

interface IRequestedStampsInfoProps {
  title: string;
  requestedStampsInfo: Array<IPodaciOTrazenimMarkicamaPrint>;
}

export const RequestedStampsInfo: React.FC<IRequestedStampsInfoProps> = ({
  title,
  requestedStampsInfo,
}) => {
  const { exciseStamps, setExciseStamps } = useContext(ExciseStampsContext);
  const { ministry } = useContext(MinistryContext);

  const LayoutTitle = () => {
    if (["kafu", "кафу", "kafa", "кафa"].includes(title)) {
      return (
        <>
          <Col className={style.fontSize} span={5}>
            {MandatoryField("AKCIZNE_MARKICE.VRSTE_AKCIZNE_MARKICE")}
          </Col>
          <Col className={style.fontSize} span={5}>
            {MandatoryField("AKCIZNE_MARKICE.OZNAKA_PAKOVANJA")}
          </Col>
          {exciseStamps.kategorijeZaZahtev.tipPakovanjaShow && (
            <Col className={style.fontSize} span={5}>
              {MandatoryField("AKCIZNE_MARKICE.VELICINA_PAKOVANJA")}
            </Col>
          )}
          <Col className={style.fontSize} span={5}>
            {MandatoryField("AKCIZNE_MARKICE.TRAZENE_KOLICINE")}
          </Col>
          <Col span={6}></Col>
        </>
      );
    }

    return (
      <>
        <Col className={style.fontSize} span={8}>
          {MandatoryField("AKCIZNE_MARKICE.VRSTE_AKCIZNE_MARKICE")}
        </Col>
        {exciseStamps.kategorijeZaZahtev.tipPakovanjaShow && (
          <Col className={style.fontSize} span={6}>
            {MandatoryField("AKCIZNE_MARKICE.VELICINA_PAKOVANJA")}
          </Col>
        )}
        <Col className={style.fontSize} span={6}>
          {MandatoryField("AKCIZNE_MARKICE.TRAZENE_KOLICINE")}
        </Col>
        <Col span={8}></Col>
      </>
    );
  };

  const hiddenColumns = useMemo(() => {
    const columns: RequestedStampsInfoTableColumnName[] = [
      "nedostajuceVrednosti",
      "opseg",
    ];

    if (
      exciseStamps.kategorijaProizvodaId !==
        AkciznaMarkicaKategorijaProzivoda.KAFA &&
      ministry.kategorijaProizvodaId !== AkciznaMarkicaKategorijaProzivoda.KAFA
    ) {
      columns.push("pakovanjeOznaka");
    }

    if (
      !exciseStamps.kategorijeZaZahtev.tipPakovanjaShow &&
      !exciseStamps.tipPakovanjaShow
    ) {
      columns.push("tipPakovanja");
    }

    return columns;
  }, [
    exciseStamps.kategorijaProizvodaId,
    exciseStamps.kategorijeZaZahtev.tipPakovanjaShow,
    exciseStamps.tipPakovanjaShow,
    ministry,
  ]);

  const removeRowHandler = (requestedStampIndex: number) => {
    setExciseStamps({
      podaciOTrazenimMarkicama: exciseStamps.podaciOTrazenimMarkicama.filter(
        (_exciseStamp, index) => index !== requestedStampIndex
      ),
      podaciOTrazenimMarkicamaPrint:
        exciseStamps.podaciOTrazenimMarkicamaPrint.filter(
          (_exciseStamp, index) => index !== requestedStampIndex
        ),
    });
  };

  return (
    <Col className={style.mainContainer} span={24}>
      <Col className={style.title} span={24}>
        {t("AKCIZNE_MARKICE.PODACI_O_TRAZENIM_AKCIZNIM_MARKICAMA")}
      </Col>
      <Row className={style.row}>{LayoutTitle()}</Row>
      <ChooseRequestedStampsRow title={title} />

      <RequestedStampsInfoTable
        requestedStampsInfo={requestedStampsInfo.map(
          mapPodaciOTrazenimMarkicamaPrint
        )}
        hiddenColumns={hiddenColumns}
        rowAction={removeRowHandler}
        expandable={false}
        editable
      />
    </Col>
  );
};
